module.exports = __webpack_public_path__ + "assets/img/3_1302.47645dd1.jpg";